const namedColors: Array<[RegExp, number]> = [
  [/(air|barrier|structure_void)$/, 0x000000],
  [/(water|ice)/, 0x4b82c3],
  [/(lava|magma)/, 0xe4672e],
  [/(grass|moss|leaves|vine)/, 0x5f8f4e],
  [/(oak|spruce|birch|jungle|acacia|mangrove|cherry|bamboo|wood|log|planks)/, 0xa47b4d],
  [/(stone|cobble|andesite|diorite|granite|deepslate|brick)/, 0x8a8d86],
  [/(sand|sandstone)/, 0xd7c589],
  [/(glass)/, 0x9fd6db],
  [/(wool|carpet)/, 0xc95f5f],
  [/(gold)/, 0xe2b83b],
  [/(iron|quartz)/, 0xd9dedb],
  [/(coal|blackstone|obsidian)/, 0x34323c],
  [/(dirt|mud|soul_soil)/, 0x79533a],
  [/(torch|lantern|glowstone|light)/, 0xf0b84d],
];

function hashName(name: string): number {
  let hash = 2166136261;
  for (const character of name) {
    hash ^= character.charCodeAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function blockColor(name: string): number {
  const normalized = name.toLowerCase();
  const named = namedColors.find(([pattern]) => pattern.test(normalized));
  if (named) return named[1];

  const hash = hashName(normalized);
  const red = 76 + (hash & 0x5f);
  const green = 76 + ((hash >> 8) & 0x5f);
  const blue = 76 + ((hash >> 16) & 0x5f);
  return (red << 16) | (green << 8) | blue;
}

/**
 * ゲームの中では見えないブロック。構造空間・バリア・光源ブロックも空気として扱い、
 * 黒い立方体が現れて隣の面まで隠してしまわないようにする。
 */
export function isAir(name: string): boolean {
  return /(^|:)(air|cave_air|void_air|structure_void|barrier|light|light_block)$/.test(name.toLowerCase());
}
